export default __webpack_public_path__ + "static/media/user-charles.cadf962f.png";